import { dbGetVideo, dbUpdateVideo } from '@/db/actions'
import { useDataStore } from '../../use-data-store'
import { processFileChunk as processFileChunk } from '../process-file-chunk'
import { MachineOutMessage } from '@uv/machine'

export const handleFileReadVideo = async ({
  file,
  fileContents,
  offset
}: {
  file: Extract<MachineOutMessage, { out: 'file_read' }>['file']
  fileContents: Extract<MachineOutMessage, { out: 'file_read' }>['payload']
  offset: Extract<MachineOutMessage, { out: 'file_read' }>['offset']
}) => {
  if (!file.endsWith('.ts')) return
  const sendMachineSyncFilesAction = useDataStore.getState().sendMachineSyncFilesAction

  let videoInLocalDb = await dbGetVideo(file)

  // -------------------------------------------------
  // 1. Video should be deleted from machine send `file_remove`
  // -------------------------------------------------
  if (videoInLocalDb?.shouldDelete === 1) {
    return sendMachineSyncFilesAction({
      in: 'file_remove',
      file
    })
  }

  // -------------------------------------------------
  // 2. Process Chunk
  // -------------------------------------------------
  const chunkAction = processFileChunk(file, fileContents, offset)
  const isLastChunk = chunkAction.action === 'FILE_COMPLETED'

  // -------------------------------------------------
  // 3. If video in local db, has no file, and is lastChunk save the file
  // -------------------------------------------------
  if (videoInLocalDb && videoInLocalDb.hasFile === 0 && isLastChunk) {
    await dbUpdateVideo({ fileName: file, file: chunkAction.file, hasFile: 1 })
    videoInLocalDb = await dbGetVideo(file)
  }

  // -------------------------------------------------
  // 4. Sync with Cloud
  // We should not sync with cloud because since we are sending many chunks this will flood the server
  // -------------------------------------------------
  // const hasInternetConnection = await isOnline()
  // if (hasInternetConnection) {
  //   const filesWithSyncActions = await cloudSyncVideos([
  //     {
  //       fileName: file,
  //       duration: videoInLocalDb?.duration,
  //       hasFile: Boolean(videoInLocalDb)
  //     }
  //   ])
  //
  //   if (filesWithSyncActions) {
  //     const syncAction = filesWithSyncActions.at(0)
  //
  //     // All the actions are the same, except for the file_read, which accounts for chunks
  //     if (syncAction?.action === 'FILE_READ') {
  //       return sendMachineSyncFilesAction({
  //         in: 'file_read',
  //         file,
  //         offset: hasMoreChunks ? chunkAction.offset : 0,
  //         count: FILE_READ_CHUNK_SIZE
  //       })
  //     }
  //
  //     await handleVideoSyncActions({
  //       filesWithSyncActions
  //     })
  //
  //     return
  //   }
  // }

  // -------------------------------------------------
  // 5. We don't have the video stored (nor its duration)
  // Call `file_meta` to get the duration first
  // -------------------------------------------------
  if (!videoInLocalDb || !videoInLocalDb.duration) {
    return sendMachineSyncFilesAction({
      in: 'file_meta',
      file
    })
  }

  // -------------------------------------------------
  // 6. Don't do anything, since we might be requesting the chunk in parallel
  // Eventually the sync of this file will kick in again
  // -------------------------------------------------
  if (chunkAction.action === 'INVALID_CHUNK') {
    return
  }

  // -------------------------------------------------
  // 7. Process Next Chunk
  // -------------------------------------------------
  if (chunkAction.action === 'REQUEST_NEXT_CHUNK') {
    return sendMachineSyncFilesAction({
      in: 'file_read',
      file,
      offset: chunkAction.offset,
      count: chunkAction.count
    })
  }
}
